/**
 * Review-workflow configuration enums.
 *
 * These mirror the backend enums in `nest/database/database.enums.ts` exactly.
 * The string values are the wire format — changing one here without changing it
 * there fails silently at runtime rather than at compile time.
 */
export enum AssigneeType {
  USER = "user",
  LABEL = "label",
  ADVANCE_LABEL = "advanceLabel",
  SPECIAL = "special"
}

export enum SpecialAssignee {
  ALL_USERS = "allUsers",
  TASK_CREATOR = "taskCreator",
  RESPONSIBLE = "responsible",
  AMLCO_OFFICER = "amlcoOfficer"
}

export enum StepCompletionType {
  APPROVED = "approved",
  SIGNED = "signed"
}

export enum StepAssigneeMode {
  ALL_SELECTED = "allSelected",
  CHOOSE_AT_ASSIGNMENT = "chooseAtAssignment",
  ALL_PREVIOUS_STEPS = "allPreviousSteps"
}

export enum ConditionField {
  RISK_ASSESSMENT = "riskAssessment",
  CUSTOMER_ACCEPTANCE = "customerAcceptance"
}

export enum CustomerAcceptance {
  ACCEPTED = "accepted",
  NOT_ACCEPTED = "notAccepted"
}

/** Sort keys for the workflow list, applied client-side. */
export enum ReviewWorkflowSortBy {
  TASK_TYPE = "taskType"
}

export enum ReviewWorkflowSortOrder {
  ASC = "asc",
  DESC = "desc"
}

export const WORKFLOW_NAME_MAX_LENGTH = 200;
export const WORKFLOW_DESCRIPTION_MAX_LENGTH = 1000;
export const STEP_NAME_MAX_LENGTH = 200;

/** Mirrors `ReviewWorkflowError` on the backend. */
export enum ReviewWorkflowErrorCode {
  ALREADY_EXISTS_FOR_CATEGORY = "REVIEW_WORKFLOW_ALREADY_EXISTS_FOR_CATEGORY",
  CATEGORY_LOCKED_ACTIVE_TASKS = "REVIEW_WORKFLOW_CATEGORY_LOCKED_ACTIVE_TASKS",
  DOCUMENT_COLLECTS_SIGNATURES = "REVIEW_WORKFLOW_DOCUMENT_COLLECTS_SIGNATURES",
  CATEGORY_OVERLAP = "REVIEW_WORKFLOW_CATEGORY_OVERLAP"
}

/** Chips have no truncation of their own in `ui-dropdown-multiselect-with-chips`; see `toChipName`. */
export const LABEL_CHIP_NAME_MAX_LENGTH = 22;

/** A label can cover a whole firm; its hover names this many members, then trails off. */
export const LABEL_TOOLTIP_MAX_NAMES = 10;
